import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-dropdown-select";
import dayjs from "dayjs";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { DesktopTimePicker } from "@mui/x-date-pickers/DesktopTimePicker";
import { decrypt, encrypt } from "../utils/cryptoUtils";
import { useLocation } from "react-router-dom";
import axiosInstance from "../services/axiosInstance";
import DynamicQuestionRenderingv2 from "./dynamicQuestionRenderingv2";
import { useRef } from "react";

const cardStyle = {
  boxShadow: "0px 0px 8px rgba(44, 99, 152, 0.12)",
};

const CreateOrder = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [dentistList, setDentishList] = useState([]);
  const [orderTypeId, setOrderTypeId] = useState();
  const [errors, setErrors] = useState({});
  const [selectedWorkTypeId, setSelectedWorkTypeId] = useState(null);
  const [toothGridData, setToothGridData] = useState([]);
  const [alloyType, setAlloyType] = useState([]);
  const [selectedOrderType, setSelectedOrderType] = useState(0);
  const [selectedFlow, setSelectedflow] = useState(null);
  const [holidayList, setHolidayList] = useState([]);
  const initialRender = useRef(true);

  const [orderData, setOrderData] = useState({
    orderId: 0,
    dentistId: 0,
    patientName: "",
    deliveryDate: "",
    deliveryTime: "",
    orderTypeId: 0,
    pPD_Notes: null,
    standard_Notes: null,
    individual_Notes: null,
    jawTypeId: null,
    orderStatusId: 1,
    isActive: true,
    lastUpdatedByUserId: 0,
    dentist: null,
    orderType: null,
    jawType: null,
    toothColorId: null,
    toothColorOption: null,
    orderStatues: null,
    lastUpdatedByUser: null,
    alloyType: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setOrderData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleDateChange = (newTime) => {
    if (newTime) {
      // Set default hour to 8 if the selected time doesn't have an hour set
      const updatedTime =
        newTime.hour() === 0 ? newTime.set("hour", 0) : newTime;

      // Format time as YYYY-MM-DDTHH:mm:ss
      const formattedTime = updatedTime.format("YYYY-MM-DDTHH:mm:ss");

      setOrderData((prevState) => ({
        ...prevState,
        deliveryDate: formattedTime,
      }));

      setErrors((prevErrors) => {
        const { deliveryTime, deliveryDate, ...restErrors } = prevErrors; // Remove deliveryTime
        return restErrors;
      });
    }
  };

  const handleTimeChange = (newTime) => {
    if (newTime) {
      const hours = newTime.hour();
      const minutes = newTime.minute();

      setOrderData((prevState) => {
        const deliveryDate = prevState.deliveryDate
          ? new Date(prevState.deliveryDate)
          : new Date();

        deliveryDate.setHours(hours, minutes);
        const formattedTime = dayjs(deliveryDate).format("YYYY-MM-DDTHH:mm:ss");

        return {
          ...prevState,
          deliveryDate: formattedTime,
        };
      });

      setErrors((prevErrors) => {
        const { deliveryTime, deliveryDate, ...restErrors } = prevErrors;
        return restErrors;
      });
    }
  };

  const mapTeethData = (teethData) => {
    return teethData
      ? teethData.map((item) => ({
          index: item.toothPosition, // Map toothPosition to index
          gridLetter: item.gridLetter, // Keep gridLetter as is
          isLink: item.isLinked, // Rename isLinked to isLink
        }))
      : [];
  };

  const mapOrderObj = (orderDataObj) => {
    const orderDetailObj = {
      orderId: orderDataObj.orderId || 0,
      dentistId: orderDataObj.dentistId || 0,
      patientName: orderDataObj.patientName || "",
      deliveryDate: orderDataObj.deliveryDate || "",
      deliveryTime: orderDataObj.deliveryDate || "",
      orderTypeId: orderDataObj.orderTypeId || 0,
      workTypeId: orderDataObj?.workTypeId,
      pPD_Notes: orderDataObj?.dentist?.pP_Notes || null,
      standard_Notes: orderDataObj.standard_Notes || null,
      individual_Notes: orderDataObj.individual_Notes || null,
      jawTypeId: orderDataObj.jawTypeId || null,
      orderStatusId: orderDataObj.orderStatusId || 1,
      isActive: orderDataObj.isActive || true,
      lastUpdatedByUserId: orderDataObj.lastUpdatedByUserId || 1,
      dentist: orderDataObj.dentist || null,
      orderType: orderDataObj.orderType || null,
      jawType: orderDataObj.jawType || null,
      orderStatues: orderDataObj.orderStatues || null,
      toothColorId: orderDataObj.toothColorId || null,
      toothColorOption: orderDataObj.toothColorOption || null,
      selectedTeeths: mapTeethData(orderDataObj.teeths) || null,
      lastUpdatedByUser: orderDataObj.lastUpdatedByUser || null,
      alloyTypeID: orderDataObj.alloyTypeID,
    };

    setOrderData(orderDetailObj);
    setToothGridData(orderDetailObj?.selectedTeeths);
    setAlloyType(orderDetailObj?.alloyTypeID);
    return orderDetailObj;
  };

  useEffect(() => {
    const getHolidayList = async () => {
      try {
        const OrderInfo = await axiosInstance.get("/api/Order/getHolidayList");
        const holidayDateList = OrderInfo.map((x) => {
          return new Date(x.holidayYear, x.holidayMonth - 1, x.holidayDay);
        });

        setHolidayList(
          holidayDateList.map(
            (dateStr) => new Date(dateStr).toISOString().split("T")[0]
          )
        );
      } catch (error) {
        console.error("Failed to fetch user data:", error);
      }
    };

    getHolidayList();
  }, []);

  useEffect(() => {
    getDetails();
    const encryptedId = getQueryParams();

    if (encryptedId) {
      const decryptedId = decrypt(encryptedId);
      //console.log(decryptedId);
      const fetchOrderDetails = async () => {
        try {
          const response = await axiosInstance.post(
            "/api/Order/getOrderDetails",
            {
              orderId: parseInt(decryptedId),
            }
          );

          var currentOrderDetails = await mapOrderObj(response);
          currentOrderDetails &&
            currentOrderDetails?.orderTypeId &&
            setSelectedOrderType(
              currentOrderDetails?.orderTypeId && false ? "1" : "2"
            );

          // getQuestions(currentOrderDetails?.orderTypeId);
          setOrderTypeId(currentOrderDetails?.orderTypeId);
          //console.log(currentOrderDetails);
        } catch (error) {
          console.error("Fehler beim Abrufen der Auftragsdaten:", error);
        }
      };

      if (decryptedId) {
        fetchOrderDetails();
      }
    } else {
      console.log("No encrypted ID found");
    }
  }, []);

  const getQueryParams = () => {
    const queryParams = new URLSearchParams(location.search);
    const orderId = queryParams.get("orderId");
    return orderId;
  };

  const getDetails = async () => {
    try {
      const OrderInfo = await axiosInstance.get(
        "/api/Order/getDentailOrderInfo"
      );

      setDentishList(OrderInfo.dentist);
    } catch (error) {
      console.error("Failed to fetch user data:", error);
    }
  };

  const saveCreateOrder2 = async () => {
    var IsvalidForm = validateForm();

    if (IsvalidForm) {
      try {
        const mappedToothGridData = toothGridData.map((toothCellObj) => ({
          orderId: orderData.orderId,
          toothPosition: toothCellObj.index,
          gridLetter: toothCellObj.gridLetter,
          IsLinked: toothCellObj.isLink,
        }));

        const response = await axiosInstance.post("/api/Order/updateOrder", {
          dentistId: orderData.dentistId,
          patientName: orderData.patientName,
          deliveryDate: orderData.deliveryDate,
          deliveryTime: orderData.deliveryTime,
          orderTypeId: orderData.orderTypeId,
          orderId: orderData.orderId,
          workTypeId: orderData.workTypeId,
          standard_Notes: orderData.standard_Notes,
          individual_Notes: orderData.individual_Notes,
          jawTypeId: orderData.jawTypeId,
          toothColorId: orderData.toothColorId,
          toothColorOption: orderData.toothColorOption,
          pPD_Notes: orderData.pPD_Notes,
          seletedTeethList: mappedToothGridData,
          alloyTypeId: alloyType,
        });

        const encryptedOrderId = encrypt(response.orderId);
        navigate(`/workflow-planning?orderId=${encryptedOrderId}`);
      } catch (ex) {
        alert(ex);
      }
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!orderData.patientName || orderData.patientName?.trim() === "") {
      newErrors.patientName = "Patienten Name erforderlich.";
    }
    if (!orderData.deliveryDate || orderData.deliveryDate.trim() === "") {
      newErrors.deliveryDate = "Lieferdatum erforderlich.";
    } else {
      const deliveryDate = new Date(orderData.deliveryDate); // Directly parse ISO 8601 format

      if (isNaN(deliveryDate.getTime())) {
        newErrors.deliveryDate = "Ungültiges Lieferdatum";
      } else {
        // Remove time component for a fair comparison
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset time to 00:00:00

        if (deliveryDate < today) {
          newErrors.deliveryDate =
            "Das Lieferdatum darf nicht in der Vergangenheit liegen";
        }
      }
    }
    if (!orderData.deliveryDate || orderData.deliveryDate.trim() === "") {
      newErrors.deliveryTime = "Bitte wähle eine Uhrzeit.";
    } else {
      const deliveryTime = new Date(orderData.deliveryDate);

      const currentDate = new Date();
      if (currentDate > deliveryTime) {
        newErrors.deliveryTime = "Ungültige Lieferzeit";
      }
    }
    if (!orderData?.workTypeId || orderData?.workTypeId < 0) {
      newErrors.workTypeId = "Bitte fülle alle Felder aus";
    }
    // Condition for jawTypeId
    if (
      !orderData.jawTypeId && // Check if jawTypeId is not selected
      selectedFlow?.jawTypes_JSON != null // Check if jawTypes_JSON is not null
    ) {
      newErrors.workTypeId = "Bitte fülle alle Felder aus"; // Specific error message for jaw type
    }

    // // Condition for toothColors_JSON
    // if ( !(orderData?.toothColorOption && orderData?.toothColorId) && // Check if toothColorOption and toothColorId are not selected
    //   selectedFlow?.toothColors_JSON != null // Check if toothColors_JSON is not null
    // ) {
    //   newErrors.workTypeId = "Bitte fülle alle Felder aus"; // Specific error message for tooth color
    // }
    // if (
    //   selectedFlow?.gridLetters != null &&
    //   (!Array.isArray(toothGridData) || toothGridData?.length === 0)
    // ) {
    //   newErrors.workTypeId = "Bitte fülle alle Felder aus";
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const DashboardPage = () => {
    navigate("/dashboard");
  };

  return (
    <div className="">
      <div
        className="relative rounded-[20px] bg-blue-400 mt-5
     before:content-[''] before:bottom-0 before:left-0 before:w-[240px] before:h-[700px] before:bg-cover before:bg-left-bottom before:bg-no-repeat before:absolute before:bg-[url('./assets/images/round_border_bg_left.svg')] before:hidden lg:before:block
     after:content-[''] after:top-0 after:right-0 after:w-[308px] after:h-[540px] after:bg-cover after:bg-right-top after:bg-no-repeat after:absolute after:bg-[url('./assets/images/round_border_bg_right.svg')] after:hidden lg:after:block z-0
      "
        style={cardStyle}
      >
        <div className="bg-blue p-3 sm:p-4 text-center rounded-t-[20px]">
          <h1 className="text-3xl sm:text-5xl xl:text-4xl 3xl:text-5xl text-white font-robotoBold">
            Hier Bestellung erstellen!
          </h1>
        </div>
        <div className="py-8 sm:py-14 xl:py-10 3xl:py-14 overflow-hidden relative">
          <form className="2xl:w-7/12 lg:w-2/3 w-11/12 sm:w-4/5 mx-auto z-10 relative">
            <div className="mb-5 font-inter relative">
              <label
                className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl font-inter mb-2"
                htmlFor="options"
              >
                Praxis
                <sup className="text-red">*</sup>
              </label>

              <Select
                className="!px-5 appearance-none !border h-12 sm:h-12 xl:h-10 3xl:h-12 !border-gray !leading-relaxed text-xl sm:!text-2xl xl:!text-sm 3xl:!text-2xl bg-white !rounded-lg w-full 2xl:min-w-[250px] py-2 sm:!py-3 px-3 sm:!px-5 text-gray-600 placeholder:text-base sm:placeholder:!text-2xl xl:placeholder:!text-sm 3xl:placeholder:!text-2xl placeholder:!text-gray-400 hover:!border-blue-600 focus:!border-blue-600 focus:!outline-none !shadow-none"
                // style={{ padding: "30px" }}
                name="dentistId"
                options={dentistList}
                labelField="dentistDisplayName"
                valueField="dentistDisplayName"
                placeholder="Praxis"
                values={dentistList.filter(
                  (data) => data.dentistId === orderData.dentistId
                )}
                onChange={(selectedOptions) => {
                  if (selectedOptions[0]) {
                    const selectedDentist = selectedOptions[0];
                    setOrderData((prevState) => ({
                      ...prevState,
                      pPD_Notes: selectedDentist.pP_Notes,
                      dentistId: selectedDentist?.dentistId,
                      standard_Notes: "",
                    }));
                  }

                  setErrors((prevErrors) => {
                    const { dentistId, ...restErrors } = prevErrors;
                    return restErrors;
                  });
                }}
              />
            </div>
            <div className="mb-5 font-inter">
              <label
                className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl font-inter mb-2"
                htmlFor="id"
              >
                Patient
                <sup className="text-red">*</sup>
              </label>
              <input
                className="appearance-none border h-12 xl:h-10 3xl:h-12 border-gray rounded-lg w-full pl-[20px] xl:pl-3 3xl:pl-[20px] pr-5 xl:pr-3 3xl:pr-5 py-3 xl:py-2 3xl:py-3 text-gray-600 placeholder:text-gray-400 hover:border-blue-600 focus:border-blue-600 focus:outline-none focus:shadow-outline"
                id="username"
                name="patientName"
                type="text"
                placeholder="Patient"
                value={orderData.patientName}
                onChange={(event) => {
                  handleChange(event);
                  setErrors((prevErrors) => {
                    const { patientName, ...restErrors } = prevErrors;
                    return restErrors;
                  });
                }}
              />

              {/* Error message for Patient Name */}
              {errors.patientName && (
                <p className="text-red text-sm mt-1">{errors.patientName}</p>
              )}
            </div>
            <div className="relative mb-5 font-inter">
              <label
                htmlFor="date"
                className="block text-gray-600  text-2xl xl:text-sm 3xl:text-2xl font-inter mb-2"
              >
                Lieferdatum
                <sup className="text-red">*</sup>
              </label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div className="!w-full !min-w-full">
                  <DemoItem>
                    <DesktopDatePicker
                      className="width-full appearance-none bg-white !border !border-gray !rounded-lg !w-full !min-w-full !text-gray-600 placeholder:!text-gray-400 focus:!border-blue-600 placeholder:!text-2xl hover:!border-blue-600 focus:!outline-none focus:!shadow-outline flex items-center justify-between"
                      disablePast
                      shouldDisableDate={(date) => {
                        const day = date.day(); // 0 = Sunday, 6 = Saturday
                        const formattedDate = date.toISOString().split("T")[0];
                        return (
                          day === 0 ||
                          day === 6 ||
                          holidayList.includes(formattedDate)
                        );
                      }}
                      value={dayjs(
                        orderData?.deliveryDate?.split("T")[0].toString()
                      )}
                      onChange={handleDateChange}
                      slotProps={{
                        textField: {
                          onKeyDown: (e) => e.preventDefault(), // Blocks keyboard input
                        },
                      }}
                    />
                  </DemoItem>

                  {/* Error message for Delivery Date */}
                  {errors.deliveryDate && (
                    <p className="text-red text-sm mt-1">
                      {errors.deliveryDate}
                    </p>
                  )}
                </div>
              </LocalizationProvider>
            </div>
            <div className="relative mb-5 font-inter">
              <label
                htmlFor="date"
                className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl font-inter mb-2"
              >
                Uhrzeit
                <sup className="text-red">*</sup>
              </label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoItem>
                  <DesktopTimePicker
                    onChange={handleTimeChange}
                    value={
                      orderData?.deliveryDate &&
                      dayjs(orderData.deliveryDate).isValid() &&
                      !(
                        dayjs(orderData.deliveryDate).hour() === 0 &&
                        dayjs(orderData.deliveryDate).minute() === 0 &&
                        dayjs(orderData.deliveryDate).second() === 0
                      )
                        ? dayjs(orderData.deliveryDate)
                        : null
                    }
                    views={["hours"]}
                    ampm={false}
                    responsive={false}
                    slotProps={{ textField: { readOnly: true } }}
                    className="width-full appearance-none bg-white !border !border-gray font-inter !rounded-lg !w-full !min-w-full !text-gray-600 !placeholder:text-gray-400 !focus:border-blue-600 !placeholder:text-2xl !hover:border-blue-600 !focus:outline-none !focus:shadow-outline flex items-center justify-between"
                  />
                </DemoItem>

                {/* Error message for Delivery Date */}
                {errors.deliveryTime && (
                  <p className="text-red text-sm mt-1">{errors.deliveryTime}</p>
                )}
              </LocalizationProvider>
            </div>
            <div className="relative mb-5 font-inter">
              <p className="text-gray-600 text-2xl xl:text-sm 3xl:text-2xl font-interRegular mb-2">
                <label htmlFor="date" className=" font-inter">
                  {" "}
                  Auftragsart :
                </label>{" "}
                {orderData?.orderType?.orderTypeName}
              </p>
            </div>
            <hr className="border-gray my-5 xl:my-4 3xl:my-7"></hr>
            <div className="relative mb-5 font-inter">
              <label
                htmlFor="date"
                className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl  font-inter mb-2"
              >
                Praxis-Hinweis
                <sup className="text-red">*</sup>
              </label>
              <textarea
                className="appearance-none border border-gray rounded-lg font-inter w-full bg-[rgba(239,239,239,0.8)] !py-3 !px-5 xl:!py-2 xl:!px-3 3xl:!py-3 3xl:!px-5 text-gray-600 placeholder:text-gray-400 focus:border-blue-600 focus:outline-none focus:shadow-outline"
                disabled
                value={orderData.pPD_Notes}
              />
            </div>

            {/* Dynamic question rendering */}
            <DynamicQuestionRenderingv2
              initialRender={initialRender}
              orderData={orderData}
              setOrderData={setOrderData}
              mapOrderObj={mapOrderObj}
              toothGridData={toothGridData}
              setToothGridData={setToothGridData}
              alloyType={alloyType}
              setAlloyType={setAlloyType}
              orderTypeId={orderTypeId}
              selectedFlow={selectedFlow}
              setSelectedflow={setSelectedflow}
              errors={errors}
            />

            <div className="relative mb-5 font-inter">
              <label
                htmlFor="date"
                className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl font-inter mb-2"
              >
                Bitte Beachten
              </label>
              <textarea
                className="appearance-none border border-gray rounded-lg font-inter w-full bg-[rgba(239,239,239,0.8)] !py-3 !px-5 xl:!py-2 xl:!px-3 3xl:!py-3 3xl:!px-5 text-gray-600 placeholder:!text-gray-400 placeholder:!text-2xl xl:placeholder:!text-sm 3xl:placeholder:!text-2xl hover:!border-blue-600 focus:!border-blue-600 focus:!outline-none focus:!shadow-outline"
                disabled
                value={
                  (selectedWorkTypeId && selectedWorkTypeId > 0) ||
                  orderData.workTypeId > 0
                    ? orderData?.standard_Notes
                    : ""
                }
              />
            </div>
            <div className="relative mb-5 font-inter">
              <label
                htmlFor="date"
                className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl font-inter mb-2"
              >
                Individuelle Notiz
              </label>
              <textarea
                className="appearance-none border border-gray rounded-lg font-inter w-full bg-white py-3 px-5 text-gray-600 placeholder:!text-2xl xl:placeholder:!text-sm 3xl:placeholder:!text-2xl placeholder:!text-gray-400 hover:!border-blue-600 focus:!border-blue-600 focus:!outline-none focus:!shadow-outline"
                placeholder="Individuelle Notiz…"
                maxLength={1000}
                name="individual_Notes"
                value={orderData.individual_Notes}
                onChange={(event) => {
                  handleChange(event);
                  setErrors((prevErrors) => {
                    const { individualNotes, ...restErrors } = prevErrors;
                    return restErrors;
                  });
                }}
              />
            </div>
          </form>
        </div>
      </div>
      <div className="pb-12 2xl:pb-0 flex items-center justify-end gap-5 mt-5">
        <button
          className="px-5 py-2 border text-2xl xl:!text-base 3xl:!text-2xl uppercase border-blue-500 text-blue font-robotoBold rounded-lg hover:bg-blue-800 hover:border-blue-800 hover:text-white transition duration-300"
          onClick={DashboardPage}
        >
          Abbrechen
        </button>
        <button
          className="bg-blue text-2xl xl:!text-base 3xl:!text-2xl uppercase border border-blue hover:bg-blue-800 hover:border-blue-800 text-white font-robotoBold py-2 px-5 rounded-lg focus:outline-none focus:shadow-outline transition-all ease-in"
          type="button"
          onClick={saveCreateOrder2}
        >
          Weiter
        </button>
      </div>
    </div>
  );
};

export default CreateOrder;
